import ExternalLink from "../../../assets/common/external_link.svg";

export const LoginHeader = () => { 

    return (
        <div className="login-header">
            <div className="flex justify-between items-center">
                <h4 className="font-medium text-white">MerchStore</h4>
                <a href="https://www.merchology.com" target="_blank" rel="noreferrer"><img alt="External Link to Merchology" src={ExternalLink} /></a>
            </div>
            <h1 className="font-bold text-white">Dashboard</h1>
        </div>

    )
}